import { render, staticRenderFns } from "./No00.vue?vue&type=template&id=15afc96c&scoped=true"
import script from "./No00.vue?vue&type=script&lang=js"
export * from "./No00.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15afc96c",
  null
  
)

export default component.exports